/**
 * Constants for permission strings used throughout the application
 */
export const PERMISSIONS = {
  COMPANY_WALLET: 'company_wallet',
  TEAMS: 'teams',
  COMPANY_PROFILE: 'company_profile',
} as const;

// Type for permission strings
// export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS]; 